// extracted by mini-css-extract-plugin
export default {"card":"h2-z","carouselContainer":"i2-z","carouselContent":"j2-z"};